import { MoreVertical, Trash2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface ProjectActionsMenuProps {
  canDeleteProject: boolean
  canDeleteSale: boolean
  onDeleteProject: () => void
  onDeleteSale: () => void
}

/**
 * SOLY-ORDER-002 fiche 17 — project-header kebab, reskinned to the « corbeille » model.
 *
 * Two plain actions of increasing scope: « Supprimer la vente » (⊂) then « Supprimer le projet »
 * (⊃). The former « zone de danger » label and the destructive red are gone (AC-5): both gestures
 * are reversible, so shouting at the user here would be lying about the stakes. What actually
 * protects them is the confirmation modal, which states the deletion is restorable and — for the
 * project — that it also deletes the sale.
 *
 * Each item is HIDDEN (not disabled) when its guard fails (decision Thierry: masqué, pas désactivé).
 * Renders nothing when nothing applies.
 */
export function ProjectActionsMenu({
  canDeleteProject,
  canDeleteSale,
  onDeleteProject,
  onDeleteSale,
}: ProjectActionsMenuProps) {
  if (!canDeleteProject && !canDeleteSale) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="icon"
          className="h-7 w-7"
          aria-label="Plus d'actions"
          data-testid="project-actions-menu-btn"
        >
          <MoreVertical className="h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">

        {canDeleteSale && (
          <DropdownMenuItem onSelect={onDeleteSale} data-testid="project-delete-sale-action">
            <Trash2 className="h-4 w-4" />
            Supprimer la vente
          </DropdownMenuItem>
        )}

        {canDeleteProject && (
          <DropdownMenuItem onSelect={onDeleteProject} data-testid="project-delete-project-action">
            <Trash2 className="h-4 w-4" />
            Supprimer le projet
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
